// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container__admin[data-v-54c38a05] {\n  background-color: #f6f6f6;\n  height: 100vh;\n  width: 95%;\n}\n.bd-rd[data-v-54c38a05] {\n  border-radius: 20px;\n}\n\n/** card */\n.card[data-v-54c38a05] {\n  border: none;\n}\n.tabs-card a[data-v-54c38a05] {\n  color: #464343;\n}\n.tabs-card .active[data-v-54c38a05] {\n  font-weight: bold;\n}\n.navbar-profile[data-v-54c38a05] {\n  border-radius: 20px;\n  display: flex;\n}", ""]);
// Exports
module.exports = exports;
